import { combineReducers } from "redux";
import * as reducers from "./Reducers";

import { equipments, equipmentsForm, installations, installationsForm } from "./Reducers";

export default combineReducers({
	installations,
	installationsForm,
	equipments,
	equipmentsForm,
	...reducers,
});
